"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.breadcrumbsStepStyle = exports.breadcrumbsStepLabelStyle = exports.breadcrumbsStepConnectorStyle = void 0;
var _helpers = require("../../components/utils/helpers");
var breadcrumbsStepStyle = function breadcrumbsStepStyle(isHighContrast) {
  return {
    root: {
      '& .Mui-disabled': {
        '& .MuiCircularProgress-svg': {
          color: isHighContrast ? _helpers.agentDeveloperUtils.getSecondaryColor(170) : _helpers.agentDeveloperUtils.getSecondaryColor(300)
        },
        '& .MuiStepLabel-label': {
          color: isHighContrast ? _helpers.agentDeveloperUtils.getSecondaryColor(170) : _helpers.agentDeveloperUtils.getSecondaryColor(300),
          fontWeight: 'normal',
          transition: 'all 0.5s'
        },
        opacity: "".concat(isHighContrast ? 1 : 0.5),
        transition: 'all 0.5s'
      },
      // Disabled
      '& .MuiStepLabel-iconContainer': {
        paddingLeft: '8px'
      },
      // Active
      '&:not(.MuiStep-completed) >:not(.Mui-disabled)': {
        '& .MuiStepLabel-label': {
          color: isHighContrast ? _helpers.agentDeveloperUtils.getSecondaryColor(195) : _helpers.agentDeveloperUtils.getSecondaryColor(300),
          fontWeight: 'bold',
          transition: 'all 0.5s'
        }
      }
    }
  };
};
exports.breadcrumbsStepStyle = breadcrumbsStepStyle;
var breadcrumbsStepLabelStyle = function breadcrumbsStepLabelStyle(isFontBigger, isHighContrast) {
  return {
    label: {
      color: isHighContrast ? _helpers.agentDeveloperUtils.getSecondaryColor(195) : _helpers.agentDeveloperUtils.getSecondaryColor(300),
      fontSize: isFontBigger ? '21px' : '18px',
      fontWeight: 'bold'
    }
  };
};
exports.breadcrumbsStepLabelStyle = breadcrumbsStepLabelStyle;
var breadcrumbsStepConnectorStyle = function breadcrumbsStepConnectorStyle(isHighContrast) {
  return {
    lineHorizontal: {
      'background-image': "linear-gradient(to right, ".concat(isHighContrast ? _helpers.agentDeveloperUtils.getSecondaryColor(170) : _helpers.agentDeveloperUtils.getSecondaryColor(300), " 33%, rgba(255,255,255,0) 0%)"),
      'background-position': 'bottom',
      'background-repeat': 'repeat-x',
      'background-size': '4px 1px',
      borderTopStyle: 'none',
      height: '1px'
    },
    root: {
      '&.Mui-disabled': {
        opacity: "".concat(isHighContrast ? 1 : 0.5)
      }
    }
  };
};
exports.breadcrumbsStepConnectorStyle = breadcrumbsStepConnectorStyle;